import type { FaireProductEntity } from "../../entity_types/product";

export const ramen_8: FaireProductEntity = {
  token: "ramen-8",
  type: "product",
  name: "Chili Crisp Noodles 6 Pack",
  brandName: "Fly By Jing",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/d1c38d6d08081673c6515aaffc669ac63b1b8852c550864e450f0bfe75519b51.png",
  priceDollars: 16.5,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/d1c38d6d08081673c6515aaffc669ac63b1b8852c550864e450f0bfe75519b51.png",
  weight: 1.2,
  dimensions: {
    width: 10,
    height: 12,
    depth: 4,
  },
  description: "Chili crisp noodles 6-pack with authentic flavor",
  categoryTokens: ["cat_food-snacks"],
  tags: ["ramen", "instant-ramen", "japanese-ramen", "chili-crisp", "premium"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
